export enum SortCriteriaOption {
    RELEVANCE = 'RELEVANCE',
    EXPIRES_AT_DESCENDING = 'EXPIRES_AT_DESCENDING',
    EXPIRES_AT_ASCENDING = 'EXPIRES_AT_ASCENDING',
    WEIGHT_DESCENDING = 'WEIGHT_DESCENDING',
    WEIGHT_ASCENDING = 'WEIGHT_ASCENDING',
    PRICE_DESCENDING = 'PRICE_DESCENDING',
    PRICE_ASCENDING = 'PRICE_ASCENDING',
    WIDTH_DESCENDING = 'WIDTH_DESCENDING',
    WIDTH_ASCENDING = 'WIDTH_ASCENDING',
}
